
import { ref, computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

import { AreaPermitZone } from '@/store/types';

import Anchor from '@/elements/anchor/Anchor.vue';
import Button from '@/elements/button/Button.vue';
import Input from '@/elements/inputs/Input.vue';
import Message from '@/components/message/Message.vue';
import Result from '@/components/permit/PermitLookupResult.vue';
import Select from '@/elements/inputs/Select.vue';

export default defineComponent({
  name: 'PermitLookup',
  components: {
    Anchor,
    Button,
    Input,
    Result,
    Select,
    Message,
  },
  setup() {
    const { t, locale } = useI18n();
    const licensePlate = ref('');
    const zone = ref('');

    const store = useStore();

    store.dispatch('retrieveZones');

    function handleSubmit() {
      if (licensePlate.value && zone.value) {
        store.dispatch('searchLicense', {
          licensePlate: licensePlate.value,
          zone: zone.value,
        });
      }
    }

    const emailAddress = 'pbotparkingpermits@portlandoregon.gov';
    const emailSubject = 'Unable to use Area Parking Permit Lookup';

    const emailLink = `mailto:${emailAddress}?subject=${emailSubject}`;

    return {
      t,
      locale,
      licensePlate,
      zone,
      handleSubmit,
      emailAddress,
      emailLink,
      isLoading: computed(() => store.state.loading),
      permit: computed(() => store.state.permit),
      zones: computed(() =>
        Array.from(
          store.state.zones
            .reduce(
              (acc: Map<string, AreaPermitZone>, curr: AreaPermitZone) => {
                if (!acc.has(curr.id) && !curr.subSection) {
                  acc.set(curr.id, curr);
                }
                return acc;
              },
              new Map<string, AreaPermitZone>()
            )
            .values()
        )
      ),
      error: computed(() => store.state.error),
    };
  },
});
